// client/src/store/slices/StudentAuthSlice.js
// Manages authenticated student state (separate from StudentSlice which manages admin's student list)

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    student: null,
};

const studentAuthSlice = createSlice({
    name: 'studentAuth',
    initialState,
    reducers: {
        setStudentAuth(state, action) {
            state.isAuthenticated = true;
            state.student = action.payload.student;
        },
        clearStudentAuth(state) {
            state.isAuthenticated = false;
            state.student = null;
        },
        updateStudentAuth(state, action) {
            if (state.student) {
                state.student = { ...state.student, ...action.payload };
            }
        },
    },
});

export const { setStudentAuth, clearStudentAuth, updateStudentAuth } = studentAuthSlice.actions;
export default studentAuthSlice.reducer;
